/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-05-05 00:42:14
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import type { AppPermissionState, AppPermissionAction } from 'stores/flow-type/app-permission.type';

import {
  UPDATE_SCOPES_REQUEST,
  UPDATE_SCOPES_SUCCESS,
  UPDATE_SCOPES_FAILURE
} from 'stores/flow-type/app-permission.type';

const initialState: AppPermissionState = {
  loading: false,
  success: false,
  error: undefined,
  accessScopes: {}
};

const appPermissionReducers = (
  state: AppPermissionState = initialState,
  action: AppPermissionAction
) => {
  switch (action.type) {
    case UPDATE_SCOPES_REQUEST:
      return { ...state, loading: true };
    case UPDATE_SCOPES_SUCCESS: {
      const { data } = action.payload;
      const accessScopes = _.get(data, 'accessScopes', {});

      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        accessScopes
      };
    }
    case UPDATE_SCOPES_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default appPermissionReducers;
